export const getCursorFromUrl = (url) => {
  if (!url || (url && !url.includes('?'))) return url;
  const params = new URLSearchParams(url.split('?')[1]);
  return params.get('cursor');
};
